'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncIterator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var configure = require('./lib/configure.js');

var toUrlSearchParams = require('./lib/to-url-search-params.js');

var stat = require('./files/stat.js');

var createLs = configure.configure(function (api, opts) {
  function ls(_x) {
    return _ls.apply(this, arguments);
  }

  function _ls() {
    _ls = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(path) {
      var options,
          pathStr,
          mapLink,
          _mapLink,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          result,
          links,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _mapLink = function _ref2() {
                _mapLink = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee(link) {
                  var hash, ipfsPath, stats, entry;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          hash = link.Hash;

                          if (!hash.includes('/')) {
                            _context.next = 9;
                            break;
                          }

                          ipfsPath = hash.startsWith('/ipfs/') ? hash : "/ipfs/".concat(hash);
                          _context.next = 5;
                          return stat.createStat(opts)(ipfsPath);

                        case 5:
                          stats = _context.sent;
                          hash = stats.cid;
                          _context.next = 10;
                          break;

                        case 9:
                          hash = cid.CID.parse(hash);

                        case 10:
                          entry = {
                            name: link.Name,
                            path: pathStr + (link.Name ? "/".concat(link.Name) : ''),
                            size: link.Size,
                            cid: hash,
                            type: typeOf(link)
                          };

                          if (link.Mode) {
                            entry.mode = parseInt(link.Mode, 8);
                          }

                          if (link.Mtime !== undefined && link.Mtime !== null) {
                            entry.mtime = {
                              secs: link.Mtime
                            };

                            if (link.MtimeNsecs !== undefined && link.MtimeNsecs !== null) {
                              entry.mtime.nsecs = link.MtimeNsecs;
                            }
                          }

                          return _context.abrupt("return", entry);

                        case 14:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _mapLink.apply(this, arguments);
              };

              mapLink = function _ref(_x2) {
                return _mapLink.apply(this, arguments);
              };

              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              pathStr = "".concat(path instanceof Uint8Array ? cid.CID.decode(path) : path);
              _context2.next = 6;
              return _awaitAsyncGenerator(api.post('ls', {
                signal: options.signal,
                searchParams: toUrlSearchParams.toUrlSearchParams(_objectSpread({
                  arg: pathStr
                }, options)),
                headers: options.headers
              }));

            case 6:
              res = _context2.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context2.prev = 9;
              _iterator = _asyncIterator(res.ndjson());

            case 11:
              _context2.next = 13;
              return _awaitAsyncGenerator(_iterator.next());

            case 13:
              _step = _context2.sent;
              _iteratorNormalCompletion = _step.done;
              _context2.next = 17;
              return _awaitAsyncGenerator(_step.value);

            case 17:
              _value = _context2.sent;

              if (_iteratorNormalCompletion) {
                _context2.next = 37;
                break;
              }

              result = _value;
              result = result.Objects;

              if (result) {
                _context2.next = 23;
                break;
              }

              throw new Error('expected .Objects in results');

            case 23:
              result = result[0];

              if (result) {
                _context2.next = 26;
                break;
              }

              throw new Error('expected one array in results.Objects');

            case 26:
              links = result.Links;

              if (Array.isArray(links)) {
                _context2.next = 29;
                break;
              }

              throw new Error('expected one array in results.Objects[0].Links');

            case 29:
              if (links.length) {
                _context2.next = 33;
                break;
              }

              _context2.next = 32;
              return mapLink(result);

            case 32:
              return _context2.abrupt("return");

            case 33:
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(links.map(mapLink)), _awaitAsyncGenerator), "t0", 34);

            case 34:
              _iteratorNormalCompletion = true;
              _context2.next = 11;
              break;

            case 37:
              _context2.next = 43;
              break;

            case 39:
              _context2.prev = 39;
              _context2.t1 = _context2["catch"](9);
              _didIteratorError = true;
              _iteratorError = _context2.t1;

            case 43:
              _context2.prev = 43;
              _context2.prev = 44;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context2.next = 48;
                break;
              }

              _context2.next = 48;
              return _awaitAsyncGenerator(_iterator.return());

            case 48:
              _context2.prev = 48;

              if (!_didIteratorError) {
                _context2.next = 51;
                break;
              }

              throw _iteratorError;

            case 51:
              return _context2.finish(48);

            case 52:
              return _context2.finish(43);

            case 53:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[9, 39, 43, 53], [44,, 48, 52]]);
    }));
    return _ls.apply(this, arguments);
  }

  return ls;
});

function typeOf(link) {
  switch (link.Type) {
    case 1:
    case 5:
      return 'dir';

    case 2:
      return 'file';

    default:
      return 'file';
  }
}

exports.createLs = createLs;